<!--
 * @Description: 服务事项配置模板删除组dialog组件
 * @Author: sunhuihong
 * @Date: 2022-03-31 14:43:52
 * @LastEditTime: 2022-04-14 14:19:26
-->
<template>
  <div>
    <el-dialog title="提示" :visible.sync="showDeleteGroupDialog" width="480px" :before-close="handleCancel">
      <img style="width: 24px; height: 24px; display: inline-block; vertical-align: middle" 
        src="@/assets/hsvcmng/icon-hsvcmng-error.png" alt="">
      <div style="display: inline-block; font-size: 14px; margin-left: 11px;">
        <span style="color: #3E7EF5;">{{deleteCurrentMatterCfgData.name}}</span>
        <span v-show="deleteCurrentMatterCfgData.parentId == 0">分组内</span>
        <span style="color: #3E7EF5;" v-show="deleteCurrentMatterCfgData.parentId == 0">所有模版</span>
        <span v-if="deleteCurrentMatterCfgData.parentId == 0">将被删除，是否继续删除？</span>
        <span v-else>模板将被删除，是否继续删除？</span>
      </div>
      <div  class="dialog-footers">
        <el-button style="height: 30px; line-height: 2px;" type="primary" @click="handleSubmitDelete">
          确定删除
        </el-button>
        <el-button style="height: 30px; line-height: 2px;" @click="handleCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Constant from '@/global/Constant.js'
export default {
  name: "DeleteMatterCfgDetailsDialog",
  props: ["showDeleteGroupDialog", "deleteCurrentMatterCfgData"],
  data() {
    return {

    }
  },

  methods: {
    //删除接口
    deleteGroup() {
      let params = {id: this.deleteCurrentMatterCfgData.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_MATTER_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.$message.success(result.data);
        this.$emit("handle-close-delete-dialog", true);
      })
    },

    handleCancel() {
      this.$emit("handle-close-delete-dialog", false)
    },

    handleSubmitDelete(data) {
      this.deleteGroup(data.id)
      this.$emit("handle-close-delete-dialog", false)
    },
  }
};
</script>

<style  scoped>
.dialog-footers {
  text-align: center;
  margin-top: 36px;
}
</style>>



// WEBPACK FOOTER //
// src/components/hsvccfg/components/matterCfgDetails/DeleteMatterCfgDetailsDialog.vue